/**
 * Engraving Checkbox – Dawn Theme
 *
 * Paste this entire file as a new asset:
 *   Assets → Add a new asset → Create a blank file → name it engraving-checkbox.js
 *
 * Then include it in sections/main-product.liquid, just before the closing </section> tag:
 *   {{ 'engraving-checkbox.js' | asset_url | script_tag }}
 */

(function () {
  'use strict';

  // Price label is locale-aware via window.engravingStrings.price,
  // injected from the locale JSON files by product-variant-picker.liquid.
  // No language detection needed — the Liquid | t filter handles it.
  const ENGRAVING_PRICE_LABEL = (window.engravingStrings && window.engravingStrings.price) || '+100 EUR';

  // Get the engraving option's translated select name using the position
  // Liquid injected into window.engravingOptionPosition. Liquid detects the
  // position by value count (only 2 values = Yes/No option) so this works
  // regardless of what language the option name or values are translated to.
  function findEngravingOptionName() {
    var pos = window.engravingOptionPosition;
    if (!pos) return null;
    return (window.productOptionNames && window.productOptionNames[pos]) || null;
  }

  function initEngravingCheckbox(productForm) {
    // Target the select directly via its name attribute — much more reliable than label matching
    const OPTION_NAME = findEngravingOptionName();
    if (!OPTION_NAME) return; // No engraving option found on this product

    const nativeSelect = productForm.querySelector(
      `select[name="options[${OPTION_NAME}]"]`
    );

    if (!nativeSelect) return; // Select not found in this form

    // Walk up to the wrapper div Dawn puts around each variant option
    // Dawn wraps each select in: .product-form__input > .select > select
    const selectWrapper = nativeSelect.closest('.product-form__input');
    if (!selectWrapper) return;

    // Hide the original dropdown
    selectWrapper.style.display = 'none';

    // Helper: set the underlying select value and fire Dawn's change handler
    function setEngravingValue(value) {
      nativeSelect.value = value;
      nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Build the checkbox UI
    const wrapper = document.createElement('div');
    wrapper.className = 'engraving-checkbox-wrapper';

    const title = document.createElement('div');
    title.className = 'engraving-title-wrapper';
    var strings = window.engravingStrings || {};
    title.innerHTML = `
      <span class="engraving-title">
        ${strings.title || 'Engraved Detail'}
        <span class="engraving-title-small">${strings.optional || '(optional)'}</span>
      </span>
    `;

    const checkbox = document.createElement('input');
    checkbox.type    = 'checkbox';
    checkbox.id      = 'engraving-toggle-' + Math.random().toString(36).slice(2, 7);
    checkbox.checked = false;

    const labelEl = document.createElement('label');
    labelEl.htmlFor = checkbox.id;
    labelEl.innerHTML = `
      <span class="engraving-checkbox__box" aria-hidden="true"></span>
      <span class="engraving-checkbox__text">
        ${strings.checkbox || 'Add engraved detail'}
        <span class="engraving-checkbox__price">${ENGRAVING_PRICE_LABEL}</span>
      </span>
    `;

    wrapper.appendChild(title);
    wrapper.appendChild(checkbox);
    wrapper.appendChild(labelEl);

    // Insert the checkbox UI right after the drawer swatch images
    const anchorEl = document.querySelector('div.pdp-right.icon-options');
    if (anchorEl) {
      anchorEl.insertAdjacentElement('afterend', wrapper);
    } else {
      selectWrapper.insertAdjacentElement('afterend', wrapper); // fallback
    }

    // Read actual option values from the select — don't hardcode 'Yes'/'No'
    // since Shopify translates them (e.g. 'Tak'/'Nie' in Polish).
    const engravingOpts = Array.from(nativeSelect.options)
      .map(function(o) { return o.value; })
      .filter(function(v) { return v !== ''; });
    const VALUE_UNCHECKED = engravingOpts[0]; // 'No' or 'Nie'
    const VALUE_CHECKED   = engravingOpts[1] || engravingOpts[0]; // 'Yes' or 'Tak'

    // Set initial engraving value SILENTLY — no change event on the engraving
    // select, as that would trigger Dawn's resolver with only one option filled.
    nativeSelect.value = VALUE_UNCHECKED;

    // After pre-filling the engraving value, fire a change event on the DRAWER
    // select instead. Dawn then re-evaluates the full variant state with the
    // engraving already set — it correctly renders the button as greyed-out
    // "Add to cart" (waiting for drawer selection) rather than "Unavailable".
    var drawerOptionName = window.productOptionNames && window.productOptionNames[1];
    var drawerSelectEl = drawerOptionName
      ? document.querySelector('select[name="options[' + drawerOptionName + ']"]')
      : null;
    if (drawerSelectEl) {
      drawerSelectEl.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Dawn hides the price when no variant is resolved — undo that
    var priceContainer = document.querySelector('[id^="price-"]');
    if (priceContainer) {
      priceContainer.classList.remove('hidden');
    }

    // React to checkbox changes
    checkbox.addEventListener('change', function () {
      // Use dynamic option name — 'Drawer' is translated to 'Szuflada' etc.
      var drawerOptionName = window.productOptionNames && window.productOptionNames[1];
      var colourSelect = drawerOptionName
        ? document.querySelector('select[name="options[' + drawerOptionName + ']"]')
        : null;
      var noColourSelected = colourSelect && !colourSelect.value;

      if (noColourSelected && priceContainer && window.engravingPrices) {
        // Update the price display manually using Liquid-rendered prices
        var priceItem = priceContainer.querySelector('.price-item--regular');
        if (priceItem) {
          priceItem.textContent = this.checked ? window.engravingPrices.yes : window.engravingPrices.no;
        }
        // Update the underlying select value silently — no change event,
        // so Dawn doesn't re-hide the price
        nativeSelect.value = this.checked ? VALUE_CHECKED : VALUE_UNCHECKED;
        priceContainer.classList.remove('hidden');
      } else {
        setEngravingValue(this.checked ? VALUE_CHECKED : VALUE_UNCHECKED);
      }
    });
  }

  function init() {
    // Dawn renders variant selects inside <variant-selects>, not product-form
    document.querySelectorAll('variant-selects, product-form, .product-form').forEach(initEngravingCheckbox);

    // Also handle dynamically injected forms (e.g. quick-add modals loaded via fetch)
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          const forms = node.matches('variant-selects, product-form, .product-form')
            ? [node]
            : [...node.querySelectorAll('variant-selects, product-form, .product-form')];
          forms.forEach(initEngravingCheckbox);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
